import styled from '@emotion/styled';
import { ReactElement } from 'react';

import { Theme } from '../../../theme/interface/detailed';
import { useTheme } from '../../../theme/useTheme';
import { Interface } from './interface';

export const PhoneIcon = styled((props: Interface): ReactElement => {
	const theme = useTheme();
	return (
		<div {...props}>
			<svg
				width={theme.videoCalls.icons.phoneIcon.width}
				height={theme.videoCalls.icons.phoneIcon.height}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M22.803 17.431a3.871 3.871 0 00-.39-.589c-.356-.448-.839-.902-1.421-1.363a17.54 17.54 0 00-1.855-1.276c-1.026-.584-2.207-.507-2.817.476a37.204 37.204 0 01-.449.521l-.047.053c-.184.207-.352.38-.347.377-.673.456-1.113.42-1.708-.175a.884.884 0 00-1.385.174l-1.757 2.961a.884.884 0 00.135 1.076c3.766 3.767 7.523 4.636 10.675 1.483l.95-.95c.731-.73.9-1.854.416-2.768zm-1.666 1.518l-.95.95c-2.186 2.186-4.73 1.739-7.683-1.008l.898-1.514c.973.524 2.024.423 3.068-.284.173-.118.364-.315.674-.664l.052-.058a29.957 29.957 0 00.526-.612l.092-.134c.026-.047.149-.057.439.108.088.052.267.163.501.316.39.255.78.531 1.142.817.484.383.874.75 1.13 1.073.093.117.165.225.215.32a.588.588 0 01-.104.69zM6.332 14.297l2.962-1.757a.884.884 0 00.174-1.385c-.595-.595-.631-1.035-.174-1.71-.004.005.169-.162.374-.345l.055-.048a27.893 27.893 0 01.52-.448c.984-.61 1.061-1.792.483-2.808a17.56 17.56 0 00-1.282-1.864c-.46-.583-.915-1.066-1.363-1.42a3.877 3.877 0 00-.59-.391 2.356 2.356 0 00-2.767.416l-.95.95C.62 6.639 1.49 10.395 5.256 14.162a.884.884 0 001.075.135zm-1.309-9.56l.95-.95a.588.588 0 01.692-.104c.094.05.202.122.319.215.324.256.69.646 1.073 1.13A15.83 15.83 0 019.195 6.68c.16.28.15.404.103.43l-.133.091a25.766 25.766 0 00-.612.526l-.06.053c-.35.31-.547.502-.663.675-.707 1.042-.809 2.094-.284 3.067l-1.514.898C3.285 9.467 2.838 6.923 5.023 4.737zM20.166 4.756a.884.884 0 00-1.25 0L3.009 20.666a.884.884 0 101.25 1.25l15.908-15.91a.884.884 0 000-1.25z"
					fill={theme.videoCalls.icons.phoneIcon.fill}
				/>
			</svg>
		</div>
	);
})(({ theme }: { theme?: Theme }) => theme?.videoCalls.icons.phoneIcon);
